var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateArrowSixth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26,
    viewBox: "0 0 27 26",
    width: 27,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0 1 -1 0 31 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.666665 11.166855v-5.17224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.838905 5.994615h-5.17224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.103675 7.03449c5.2046567 2.46663471 7.9390475 8.2689899 6.5283654 13.8531383-1.4106821 5.5841485-6.5727477 9.3916803-12.3244451 9.0904922-5.7516975-.301188-10.4878578-4.627041-11.3075953-10.3279855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9888 5.994705c-.0000497.04139593-.033629.07492374-.075025.07490992-.0413959-.00001381-.0749529-.03356403-.0749749-.07495998-.0000221-.04139595.033499-.07498196.0748949-.07503994.019925-.00002791.0390422.00787389.0531328.02196162.0140905.01408773.0219961.03320335.0219722.05312838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.65546 7.9947c-.0000497.04139788-.0336321.07492651-.07503.07490994s-.0749534-.03357207-.0749699-.07496998c-.0000166-.04139791.033512-.07498025.0749099-.07502996.0199224-.00002392.0390358.00787964.0531231.02196694.0140873.01408729.0219908.03320063.0219669.05312306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.675 12.66138c-.00005798.0413959-.03364399.074917-.07503994.0748949-.04139595-.000022-.07494617-.033579-.07495998-.0749749-.00001382-.041396.03351399-.0749753.07490992-.075025.01992503-.0000239.03904065.0078817.05312838.0219722.01408773.0140906.02198953.0332078.02196162.0531328"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 36v-36h36v36z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowSixth);
export default __webpack_public_path__ + "static/media/rotate-arrow-sixth.761ea61b81bfd0351ca8848903ee0629.svg";
export { ForwardRef as ReactComponent };